// extracted by css-extract-rspack-plugin
export default {"pageShell":"I21jPepVJXgvHrCZ"};